import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import prototypeRoutes from './prototype/prototype-routing.module';
import { AuthGuard } from './auth/auth.guard';
import errorRoutes from './error/error-routing.module';
import tierRoutes from './tier/tier-routing.module';
import restaurantItemRoutes from './restaurant-item/restaurant-item-routing.module';
import reportsRoutes from './reports/reports-routing.module';
import adminRoutes from './admin/admin-routes.module';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      ...tierRoutes,
      ...restaurantItemRoutes,
      ...prototypeRoutes,
      ...reportsRoutes,
      ...adminRoutes,
    ],
  },
  ...errorRoutes,
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      onSameUrlNavigation: 'reload',
    }),
  ],
})
export class AppRoutingModule {}
